import { apiClient } from './api';

export enum PromotionType {
  DISCOUNT_PERCENTAGE = 'DISCOUNT_PERCENTAGE',
  DISCOUNT_AMOUNT = 'DISCOUNT_AMOUNT',
  FREE_DELIVERY = 'FREE_DELIVERY',
}

export interface Promotion {
  id: string;
  restaurantId: string;
  name: string;
  description?: string | null;
  type: PromotionType;
  discountValue?: number | null;
  minimumOrderAmount?: number | null;
  startDate: string;
  endDate: string;
  isActive: boolean;
  applicableProducts?: string[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePromotionDto {
  name: string;
  description?: string;
  type: PromotionType;
  discountValue?: number;
  minimumOrderAmount?: number;
  startDate: string;
  endDate: string;
  isActive?: boolean;
  applicableProducts?: string[] | null;
}

export const promotionService = {
  /**
   * Get restaurant promotions
   */
  async getPromotions(): Promise<Promotion[]> {
    const response = await apiClient.get<Promotion[]>('/restaurant/my/promotions');
    return response.data.data;
  },

  /**
   * Create promotion
   */
  async createPromotion(dto: CreatePromotionDto): Promise<Promotion> {
    const response = await apiClient.post<Promotion>('/restaurant/my/promotions', dto);
    return response.data.data;
  },

  /**
   * Update promotion
   */
  async updatePromotion(promotionId: string, dto: Partial<CreatePromotionDto>): Promise<Promotion> {
    const response = await apiClient.patch<Promotion>(
      `/restaurant/my/promotions/${promotionId}`,
      dto,
    );
    return response.data.data;
  },

  /**
   * Delete promotion
   */
  async deletePromotion(promotionId: string): Promise<void> {
    await apiClient.delete(`/restaurant/my/promotions/${promotionId}`);
  },
};
